import { Button, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { useDialogs } from '@mews-commander/ui';
import { ADD_SELL_LIMIT_DIALOG_NAME, DELETE_SELL_LIMIT_DIALOG_NAME } from '../constants';
import { AddSellLimitDialogForm } from './AddSellLimitDialogForm';
import { DeleteSellLimitDialogForm } from './DeleteSellLimitDialogForm/DeleteSellLimitDialogForm';

export const SellLimitActions = ({ serviceId, enterpriseId }: WithServiceId & WithEnterpriseId) => {
    const { openDialog } = useDialogs();

    return (
        <Stack spacing="100">
            <Button
                onClick={() =>
                    openDialog(
                        <DeleteSellLimitDialogForm enterpriseId={enterpriseId} serviceId={serviceId} />,
                        DELETE_SELL_LIMIT_DIALOG_NAME
                    )
                }
                variant="tertiary"
                type="submit"
            >
                {lt('SellLimitsDeleteButtonLabel')}
            </Button>
            <Button
                variant="primary"
                onClick={() =>
                    openDialog(
                        <AddSellLimitDialogForm serviceId={serviceId} enterpriseId={enterpriseId} />,
                        ADD_SELL_LIMIT_DIALOG_NAME
                    )
                }
                type="submit"
            >
                {lt('SellLimitsCreateButtonLabel')}
            </Button>
        </Stack>
    );
};
